import { makeStyles } from "@mui/styles";
import { Bold, Regular, SemiBold } from "../../../utils";

export const useStyles = makeStyles((theme) => ({
    imgbody: {
        borderRadius: "4px",
        cursor: "pointer",
        backgroundColor: "#E4EFFF",
        padding: "40px",
        height: "150px",
        marginRight: "10px",
        marginLeft: "10px"
    },
    icon: {
        display: "flex",
        justifyContent: "center",
        color: "#5078E1"
    },
    uploadedImg: {
        width: "100%",
        height: "250px",
        cursor: "pointer"
    },
    imgblock: {
        margin: "0px 30px",
        position: "relative"
    },
    selectedImg: {
        height: "100%",
        borderRadius: "4px",
        width: "100%",

    },

    text: {
        fontSize:"0.75rem",
        fontFamily: SemiBold,
        color: "#5078E1"

    },
    selectedimgbody: {

        display: "flex",
        '&:hover': {
            scale: 2
        }
    },
    imgtext: {
        position: "absolute",
        bottom: 10,
        color: "white",
        // top: "50%",
        marginLeft: "6px",
    },
    deleteicon: {
        display: "flex",
        position: "absolute",
        bottom: 0,
        top: "5%",
        color: "#FF4B4B",
        backgroundColor: "white",
        borderRadius: "50%",
        padding: "5px",
        fontSize: "2.5rem",
        right: "9px",
    },
    dot: {
        width: "4px",
        height: "4px",
        backgroundColor: "white",
        borderRadius: "50%",
        marginTop: "5px",
        marginLeft: "4px",
        marginRight: "4px",
    },
    imgName: {
        fontFamily: SemiBold,
        color: "#FFFFFF",
        fontSize:"0.75rem",
    },
    textName: {
        fontFamily: Regular,
        color: "#FFFFFF",
        fontSize:"0.75rem",
    },
    hoverCard: {
        opacity: "12",
        backgroundColor: '#0000009c',
        position: 'absolute',
        width: "100%",
        height: "150px",
        borderRadius: 4,
        top: 1,
        bottom: 0,
        right: 0,
        left: 0,
    },
    uploadbutton: {
        height: "500px"
    },

  caroselRoot: {
    borderRadius: '4px',
    backgroundColor: (props) => props?.backgroundColor ?? "",
    padding: (props) => props?.padding ?? "",
    cursor: 'pointer'
  },
  arrowBtn: {
    backgroundColor: "#fff !important",
    border: "1px solid #CED3DD",
  },
  title: {
    fontSize:"0.75rem",
    color: "#4E5A6B",
    textTransform: "upperCase",
    fontFamily: Bold,
    marginBottom: "16px"
  },
  downloadBtn:{
    textTransform:"capitalize",
    padding:"8px 12px",
    marginTop:"4px"
  }

}))